<template>
  <div class="col" v-show="selectByMonth === true">
    <label for="startMonthEl" class="form-label" style="font-size: 0.8rem">조회 월</label>
    <input class="form-control" type="month" id="startMonthEl"
           @change="handleChange($event, 'startMonth')"
           :min="getMinSearchMonth()"
           :max="getMaxSearchMonth()"
           v-model="selectedStartMonth"/>
  </div>
  <div class="col" style="margin-left: -20px" v-show="selectByMonth === true">
    <label for="startTimeEl" class="form-label" style="font-size: 0.8rem">시작시간</label>
    <select name="startTimeEl" id="startTimeEl" class="form-control"
            @change="handleChange($event, 'startMonthTime')"
            v-model="selectedStartTime">
      <option v-for="hour in timeList" :value="hour" :key="hour">{{ hour }} 시</option>
    </select>
  </div>

  <div class="col" v-show="selectByMonth !== true">
    <div class="row">
      <div class="col">
        <label for="startDateEl" class="form-label" style="font-size: 0.8rem">시작일자</label>
        <input ref="startDateElRef"
               name="startDateEl"
               id="startDateEl"
               class="form-control search-date"
               type="date"
               @blur="handleBlur($event, 'start')"
               @change="handleChange($event, 'startDate')"
               v-model="selectedStartDate" :min="getMinSearchDate()"
               max="2999-12-31" />
      </div>
      <div class="col search-time-col">
        <label for="startTimeEl" class="form-label" style="font-size: 0.8rem">시작시간</label>
        <div class="d-flex align-items-center gap-1">
        <select name="startTimeEl" id="startTimeEl" class="form-control search-date"
                @blur="handleBlur($event, 'start')"
                @change="handleChange($event, 'startTime')"
                v-model="selectedStartTime">
          <option v-for="hour in timeList" :value="hour" :key="hour">{{ hour }} 시</option>
        </select>
        <select v-if="props.showMinute" class="form-control search-date"
                @change="handleChange($event, 'startMinute')"
                v-model="selectedStartMinute">
          <option v-for="min in minuteList" :value="min" :key="min">{{ min }} 분</option>
        </select>
        </div>
      </div>
    </div>
  </div>
  <div class="col" v-show="selectByMonth !== true">
    <div class="row">
      <div class="col">
        <label for="endDateEl" class="form-label" style="font-size: 0.8rem">종료일자</label>
        <input ref="endDateElRef"
               name="endDateEl"
               id="endDateEl"
               class="form-control search-date"
               type="date"
               @blur="handleBlur($event, 'end')"
               @change="handleChange($event, 'endDate')"
               v-model="selectedEndDate" :min="getMinSearchDate()"
               max="2999-12-31" />
      </div>
      <div class="col search-time-col">
        <label for="endTimeEl" class="form-label" style="font-size: 0.8rem">종료시간</label>
        <div class="d-flex align-items-center gap-1">
        <select name="endTimeEl" id="endTimeEl" class="form-control search-date"
                @change="handleChange($event, 'endTime')"
                @blur="handleBlur($event, 'end')"
                v-model="selectedEndTime">
          <option v-for="hour in timeList" :value="hour" :key="hour">{{ hour }} 시</option>
        </select>
        <select v-if="props.showMinute" class="form-control search-date"
                @change="handleChange($event, 'endMinute')"
                v-model="selectedEndMinute">
          <option v-for="min in minuteList" :value="min" :key="min">{{ min }} 분</option>
        </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, defineProps, onMounted, ref, watch} from "vue";
import {useStore} from "vuex";
import {searchBarProps} from "@/store/searchbar";
import {
  changeFormat,
  getMinSearchDate,
  getMinSearchMonth,
  getMaxSearchMonth,
  startMonthInit, datePlus1day
} from "@/components/tacho/common/CommonFunc";
import dayjs from "dayjs";

const emit = defineEmits([]);
const props = defineProps({
  showMinute: { type: Boolean, default: false }
})
const store = useStore();
const patchSearchBar = (data) => store.dispatch('patchSearchBar', data);

// 변수
const selectedStartIso = computed(() => store.state.searchBar.selectedStartIso);
const selectedStartDate = ref(changeFormat(store.state.searchBar.selectedStartIso, 'YYYY-MM-DD'));
const selectedStartMonth = ref(changeFormat(store.state.searchBar.selectedStartIso, 'YYYY-MM'));
const selectedStartTime = ref(changeFormat(store.state.searchBar.selectedStartIso, 'HH'));
const selectedStartMinute = ref(changeFormat(store.state.searchBar.selectedStartIso, 'mm'))
const startDateElRef = ref(null);
const selectedEndIso = computed(() => store.state.searchBar.selectedEndIso);
const selectedEndDate = ref(changeFormat(store.state.searchBar.selectedEndIso, 'YYYY-MM-DD'));
const selectedEndTime = ref(changeFormat(store.state.searchBar.selectedEndIso, 'HH'));
const selectedEndMinute = ref(changeFormat(store.state.searchBar.selectedEndIso, 'mm'))
const endDateElRef = ref(null);
const selectedOffice = computed(() => store.state.searchBar.selectedOffice);
const selectByMonth = computed(() => store.state.searchBar.selectByMonth);
const timeList = computed(() => store.state.searchBar.timeList);
const settings = computed(() => store.state.searchBar.settings);
const minuteList = Array.from({ length: 60 }, (_, i) => i.toString().padStart(2, '0'));

// Methods
async function handleChange(evt, prop) {
  switch (prop) {
    case 'startMonth': {
      if (evt.target.value.length !== 7) {
        return;
      }

      const startDateJS = dayjs(`${evt.target.value}-01T${selectedStartTime.value}:00:00`);
      await patchSearchBar({
        prop: searchBarProps.selectedStartIso,
        value: startDateJS.format('YYYY-MM-DDTHH:mm:ss'),
      });
      break;
    }
    case 'startMonthTime':
      await patchSearchBar({
        prop: searchBarProps.selectedStartIso,
        value: `${selectedStartDate.value}T${evt.target.value}:00:00`,
      });
      break;

    case 'startDate':
      if (evt.target.value.length !== 10) {
        return;
      }

      await patchSearchBar({
        prop: searchBarProps.selectedStartIso,
        value: `${evt.target.value}T${selectedStartTime.value}:00:00`,
      });
      break;

    case 'startTime':
      await patchSearchBar({
        prop: searchBarProps.selectedStartIso,
        value: `${selectedStartDate.value}T${evt.target.value}:00:00`,
      });
      break;

    case 'startMinute':
      await patchSearchBar({
        prop : searchBarProps.selectedStartIso,
        value: `${selectedStartDate.value}T${selectedStartTime.value}:${evt.target.value}:00`,
      });
      break;
    case 'endDate':
      if (evt.target.value.length !== 10) {
        return;
      }
      await patchSearchBar({
        prop: searchBarProps.selectedEndIso,
        value: `${evt.target.value}T${selectedStartTime.value}:00:00`,
      });
      break;

    case 'endTime':
      await patchSearchBar({
        prop: searchBarProps.selectedEndIso,
        value: `${selectedEndDate.value}T${evt.target.value}:00:00`,
      });
      break;

    case 'endMinute':
      await patchSearchBar({
        prop : searchBarProps.selectedEndIso,
        value: `${selectedEndDate.value}T${selectedEndTime.value}:${evt.target.value}:00`,
      });
      break;
  }
}

function handleBlur(evt, prop) {
  const startDayJS = dayjs(selectedStartIso.value);
  const endDayJS = dayjs(selectedEndIso.value);

  if (startDayJS.isAfter(endDayJS)) {
    switch (prop) {
      case 'start': {
        const nextStartIso = endDayJS.subtract(1, 'day').format('YYYY-MM-DDTHH:mm:ss');
        patchSearchBar({
          prop: searchBarProps.selectedStartIso,
          value: nextStartIso,
          evt,
        });
        store.commit("openMessageBox", "시작일시가 종료일시보다 이후 입니다.");
        break;
      }
      case 'end': {
        const nextEndIso = startDayJS.add(1, 'day').format('YYYY-MM-DDTHH:mm:ss');
        patchSearchBar({
          prop: searchBarProps.selectedEndIso,
          value: nextEndIso,
          evt,
        });
        store.commit("openMessageBox", "종료일시가 시작일시보다 이전 입니다.");
        break;
      }
      default:
        console.warn('Unexpected prop:', prop);
        break;
    }
  }
}

function updateMinMaxDate() {
  const todayDate = dayjs().format('YYYY-MM-DD');
  if (startDateElRef.value) {
    startDateElRef.value.max = todayDate;
  }

  if (endDateElRef.value) {
    endDateElRef.value.min = selectedStartDate.value;
    endDateElRef.value.max = todayDate;
  }
}

onMounted(async () => {
  updateMinMaxDate();
});

watch(
    selectedStartIso,
    (after, _) => {
      selectedStartDate.value = changeFormat(after, 'YYYY-MM-DD');
      selectedStartTime.value = changeFormat(after, 'HH');
      selectedStartMonth.value = changeFormat(after, 'YYYY-MM');
      updateMinMaxDate();
    }
);

watch(
    selectedEndIso,
    (after, _) => {
      selectedEndDate.value = changeFormat(after, 'YYYY-MM-DD');
      selectedEndTime.value = changeFormat(after, 'HH');
      updateMinMaxDate();
    }
);

watch(selectedStartIso, (after) => {
  selectedStartDate.value = changeFormat(after, 'YYYY-MM-DD');
  selectedStartTime.value = changeFormat(after, 'HH');
  selectedStartMinute.value = changeFormat(after, 'mm');
});

watch(selectedEndIso, (after) => {
  selectedEndDate.value = changeFormat(after, 'YYYY-MM-DD');
  selectedEndTime.value = changeFormat(after, 'HH');
  selectedEndMinute.value = changeFormat(after, 'mm');
});

</script>

<style scoped>
.search-time-col {
  margin-left: -20px;
}
</style>
